export default {
	props: {
		id: { default: '' },
		value: { default: '' },
		label: { default: '' },
		cols: { default: '' },
		wrapped: { default: true },
		errorMessage: { default: '' },
		mask: { default: () => {
			return {
				format: '',
				inverse: false,
				change: false
			};
		} }
	},

	computed: {
		elementId() {
			return this.id || this._uid;
		}
	},

	mounted() {
		this.setEventListeners();
	},

	methods: {
		setEventListeners() {
			let events = Object.keys(this._events);
			let elements = Object.keys(this.$refs);

			elements.forEach(element => {
				events.forEach(event => {
					this.$refs[element].addEventListener(event, (e) => {
						if (event !== 'input') {
							this.$emit(event, e);
						}
					});
				});
			});
		}
	}
};


// WEBPACK FOOTER //
// ./application/components/form/base.js